import { AggregateUnitData, FilterFuncMap } from 'features/overview'
import { MapInteractionAPIs } from 'features/siteMap/SiteViewMap'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { AddPropsToFn } from 'types'

export const shouldDisplayTaggedUnit: AddPropsToFn<
  NonNullable<MapInteractionAPIs['shouldDisplayTaggedUnit']>,
  {
    indexableAggregateData: undefined | Record<string, AggregateUnitData>
    dataFilters: FilterFuncMap
  }
> = (unitID, { indexableAggregateData, dataFilters }) => {
  if (isNil(indexableAggregateData) || isEmpty(dataFilters)) {
    return true
  }

  const aggDataVal = indexableAggregateData[unitID]

  if (!aggDataVal) {
    // TODO: don't allow site-model features to be tagged to non-existant units
    return undefined
  }

  return Object.values(dataFilters).every(({ filterFunc }) => {
    return filterFunc(aggDataVal)
  })
}
